import { Dispatch, SetStateAction, createContext } from 'react';
import { ApplicationUser } from '../types/ApplicationUser';

export type AppContextType = {
  user: ApplicationUser | null;
  setUser: Dispatch<SetStateAction<ApplicationUser | null>>;
  isAuthenticated: boolean;
  isWebmaster: boolean;
  isMobile: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  isDevelopment: boolean;
  siteName: string;
  siteTagline: string;
  webmasterName: string;
  // Login overlay controls (see LoginModal).
  googleEnabled: boolean;
  showLogin: boolean;
  openLogin: () => void;
  closeLogin: () => void;
};

export default createContext<AppContextType>({
  user: null,
  setUser: () => {},
  isAuthenticated: false,
  isWebmaster: false,
  isMobile: false,
  isDesktop: false,
  isTablet: false,
  isDevelopment: false,
  siteName: '',
  siteTagline: '',
  webmasterName: '',
  googleEnabled: false,
  showLogin: false,
  openLogin: () => {},
  closeLogin: () => {},
});
